<script setup lang="ts">
import { RouterLink } from 'vue-router'
import ScanForm from '@/components/ScanForm.vue'
</script>

<template>
  <div class="mx-auto flex max-w-3xl flex-col gap-10 px-4 py-16 sm:px-6">
    <div class="flex flex-col gap-4">
      <h1 class="text-4xl font-semibold tracking-tight text-balance sm:text-5xl">
        Find out what your website gives away
      </h1>
      <p class="max-w-2xl text-lg text-pretty text-ink-muted">
        Point it at a hostname and it reports what is misconfigured: where the name resolves, how
        DNS is delegated and signed, what the certificate and the transport allow, where the entry
        points send a browser, and what the homepage and its headers disclose. Ninety-two checks,
        about thirty seconds.
      </p>
    </div>

    <div class="card p-6 sm:p-8">
      <ScanForm />
    </div>

    <ul class="flex flex-col gap-2 text-sm text-ink-muted">
      <li>No account, and nothing to install.</li>
      <li>Reports expire on their own. The scan link is the only way to read one.</li>
      <li>Every check explains what it looked at and what to do about it.</li>
    </ul>

    <p class="text-sm text-ink-muted">
      <RouterLink
        to="/checks"
        class="tap inline-flex items-center font-medium text-accent underline-offset-4 hover:underline"
      >
        See all ninety-two checks
      </RouterLink>
    </p>
  </div>
</template>
